import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Title } from '@angular/platform-browser';
import { NGXLogger } from 'ngx-logger';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { TrackingService } from 'src/app/core/services/tracking.service';
import { ScanInfo } from 'src/app/shared/models/scanInfo';
import { TrackingData } from 'src/app/shared/models/trackingData';
import { ActivatedRoute } from '@angular/router';
import {MatTableDataSource} from '@angular/material';


@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.css']
})
export class DashboardHomeComponent implements OnInit {
  currentUser: any;
  scans: ScanInfo[];
  trackingData: TrackingData;
  trackingNumber = '';
  courier = '';
  websiteLink = '';
  search = '';
  displayedColumns = ['detail', 'date', 'time', 'location'];
  dataSource = ELEMENT_DATA;
  public show = false;
  notifIcon = 'search';
  notifText = 'Please enter your tracking number.';
  parm: any;

  displayedColumns1 = ['position', 'name', 'weight', 'symbol'];
  dataSource1 = new MatTableDataSource<Element>(ELEMENT_DATA);

  constructor(private notificationService: NotificationService,
    private authService: AuthenticationService,
    private titleService: Title,
    private logger: NGXLogger,
    private trackingService: TrackingService,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => this.parm = params);
    this.currentUser = this.authService.getCurrentUser();
    this.titleService.setTitle('gotrackme - Track your Item');

    if (this.parm.tn !== undefined) {
      console.log('Tracking number passed = ', this.parm.tn);
      this.trackingNumber = this.parm.tn;
      this.search = this.trackingNumber;
      this.getFWTracking();
    }
    // this.logger.log('Dashboard loaded');

    // setTimeout(() => {
    //   this.notificationService.openSnackBar('Welcome!');
    // });
    // this.getFWTracking();
  }

  async getFWTracking() {
    console.log(this.search);
    this.trackingData = new TrackingData();
    this.trackingService.getTracking(this.search)
      .subscribe(res => {
        this.trackingData = <TrackingData>res;
        console.log(this.trackingData);
        if (this.trackingData.trackingNumber !== undefined) {
          if (this.trackingData.scans.length > 0) {
            this.scans = this.trackingData.scans;
            this.trackingNumber = this.trackingData.trackingNumber;
            this.courier = this.trackingData.courierName;
            this.websiteLink = this.trackingData.websiteLink;
            this.show = true;
          } else {
            this.invalidTrackingNumber('Invalid tracking number');
          }
        } else {
          this.invalidTrackingNumber('Invalid tracking number');
        }
    }, err => this.invalidTrackingNumber(err));
  }

  invalidTrackingNumber(err: any) {
    console.log(err);
    this.notifIcon = 'warning';
    this.notifText = 'Tracking number not found.';
    this.scans = new Array;
    // this.search = '';
    this.show = false;
    this.trackingNumber = '';
    this.courier = '';
    this.websiteLink = '';
  }

  searchAgain() {
    this.scans = new Array;
    this.search = '';
    this.show = false;
    this.trackingNumber = '';
    this.courier = '';
    this.websiteLink = '';
    this.notifIcon = 'search';
    this.notifText = 'Please enter your tracking number.';
  }

}


export interface Element {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}


const ELEMENT_DATA: Element[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  // {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  // {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  // {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  // {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  // {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  // {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  // {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  // {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
  // {position: 11, name: 'Sodium', weight: 22.9897, symbol: 'Na'},
  // {position: 12, name: 'Magnesium', weight: 24.305, symbol: 'Mg'},
  // {position: 13, name: 'Aluminum', weight: 26.9815, symbol: 'Al'},
  // {position: 14, name: 'Silicon', weight: 28.0855, symbol: 'Si'},
  // {position: 15, name: 'Phosphorus', weight: 30.9738, symbol: 'P'},
  // {position: 16, name: 'Sulfur', weight: 32.065, symbol: 'S'},
  // {position: 17, name: 'Chlorine', weight: 35.453, symbol: 'Cl'},
  // {position: 18, name: 'Argon', weight: 39.948, symbol: 'Ar'},
  // {position: 19, name: 'Potassium', weight: 39.0983, symbol: 'K'},
  // {position: 20, name: 'Calcium', weight: 40.078, symbol: 'Ca'},
];

